import { ErrorState } from '@tiendanube/components';
import { combineStatus } from 'commons/utils/combineStatus';
import { useGetIsFreePlan } from 'domains/Auth/hooks';
import { useStoreChurnedStatus } from 'domains/Billing/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { SelectChargesToPay, SelectChargesWithCreation } from './components';
import { useSelectCharges } from './hooks';
import SelectChargesToPayTabSkeleton from './Skeleton';

export function SelectChargesToPayTab() {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.paymentsTabs.toPay',
  );
  const { isTrial } = useGetIsFreePlan();

  const { planIsListed, status: chargesStatus, retryLoad } = useSelectCharges();

  const {
    status: isPaidForStatus,
    isStoreDown,
    hasActivePlanCharge,
  } = useStoreChurnedStatus();

  const { isLoading, isError } = combineStatus(isPaidForStatus, chargesStatus);

  if (isLoading) return <SelectChargesToPayTabSkeleton />;
  if (isError)
    return (
      <ErrorState
        title={t('error.title')}
        action={{ children: t('error.retry'), onClick: retryLoad }}
      />
    );

  if (!planIsListed && (isTrial || (isStoreDown && !hasActivePlanCharge))) {
    return <SelectChargesWithCreation />;
  }

  return <SelectChargesToPay />;
}
